import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiAngularSimple,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
  DiJqueryLogo,
  DiBootstrap
} from "react-icons/di";
import { SiKeras,SiTensorflow,SiOpengl,SiAdobexd,SiTrello, SiPhp, SiC,SiCplusplus, SiFirebase,SiMysql,SiHtml5,SiCsswizardry,SiFigma,SiLatex } from "react-icons/si";
import { SiOpencv,SiScikitlearn, SiMaterialui } from "react-icons/si";

function Techstack() {
  return (
    <div>
      <h4><b>Programming Languages</b></h4>
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      
      <Col xs={4} md={2} className="tech-icons">
        <DiJava /><h4>Java</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 /><h4>JavaScript</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython /><h4>Python</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPhp /><h4>PHP</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiC /><h4>C</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCplusplus /><h4>C++</h4>
      </Col>
      </Row>
      <hr />
      <h4><b>Web Development</b></h4>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
     
      <Col xs={4} md={2} className="tech-icons">
        <SiHtml5 /><h4>HTML</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiCsswizardry /><h4>CSS</h4>
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
      <br /><h4>ES6</h4>
      </Col> */}
      <Col xs={4} md={2} className="tech-icons">
        <DiJqueryLogo /><h4>jQuery</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiBootstrap /><h4>Bootstrap</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMaterialui /> <h4>Material UI</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact /><h4>React</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiAngularSimple /><h4>Angular</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs /><h4>Node.js</h4>
      </Col>
      {/* <Col xs={4} md={2} className="tech-icons">
        <br /><h4>Express.js</h4>
      </Col> */}
      </Row>
      <hr />
      <h4><b>Databases</b></h4>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql /><h4>MySQL</h4>
      </Col>
     
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb /><h4>MongoDB</h4>
      </Col>

     
   </Row>
   <hr />

   <h4><b>AI/ ML</b></h4>
   <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiTensorflow /><h4>TensorFlow</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiKeras /><h4>Keras</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
       <SiScikitlearn /><h4>scikit-learn</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiOpencv /><h4>OpenCV</h4>
      </Col>
    </Row>
<hr />
   <h4><b>Other</b></h4>
      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit /><h4>Git</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobexd /><h4>Adobe XD</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFigma /><h4>Figma</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiLatex /><h4>LaTeX</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTrello /><h4>Trello</h4>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiOpengl /><h4>OpenGL</h4>
      </Col>
    </Row>
    </div>
  );
}

export default Techstack;
